import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.css';

const Solutions = () => {
    return (
        <div className="container">
            <nav className="navbar">
                <Link to="/" className="navbar-logo">
                    <img src="/huntorca-logo.png" alt="HuntOrca Logo" className="logo-img" />
                    <h1>HuntOrca</h1>
                </Link>
                <div className="navbar-links">
                    <Link to="/" className="navbar-link">Home</Link>
                    <Link to="/pricing" className="navbar-link">Pricing</Link>
                    <Link to="/solutions" className="navbar-link active">Solutions</Link>
                    <Link to="/data-methodology" className="navbar-link">Data & Methodology</Link>
                    <Link to="/dashboard" className="navbar-button">Dashboard</Link>
                </div>
            </nav>

            <main className="solutions-main">
                <section className="solutions-hero">
                    <h1>Data-Driven Solutions for Every Solar Vertical</h1>
                    <p>Whether you're a manufacturer, distributor, or financier, our California-focused data gives you a decisive market edge.</p>
                </section>

                <section className="solutions-content">
                    <div className="solution-card">
                        <h2>For Manufacturers</h2>
                        <p>Track your equipment's market share in real-time. Identify which installers are loyal to your brand and which are using competitors. Use our data to protect your market share and find new partners.</p>
                        <ul>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Equipment Market Share Analysis</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Brand Loyalty Index</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Identify Top Installers for Partnership</li>
                        </ul>
                    </div>
                    <div className="solution-card">
                        <h2>For Distributors</h2>
                        <p>Anticipate your customers' needs before they do. Our installation velocity data helps you forecast demand and manage inventory more effectively. Find new, high-growth installers to expand your customer base.</p>
                        <ul>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Demand Forecasting with Installation Data</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Find High-Growth Installers in Your Territory</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Territory and Market Expansion Planning</li>
                        </ul>
                    </div>
                    <div className="solution-card">
                        <h2>For Financiers</h2>
                        <p>Reduce risk and improve the quality of your loan book. Our Installer Risk Score gives you a clear, data-backed signal on the stability and reliability of potential partners. Focus your capital on the most creditworthy installers.</p>
                        <ul>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Underwrite Deals with Confidence using our Risk Score</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Monitor the Health of Your Installer Network</li>
                            <li><svg className="icon" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Identify Top Performers for New Programs</li>
                        </ul>
                    </div>
                </section>
            </main>

            <footer className="footer">
                <p>&copy; {new Date().getFullYear()} HuntOrca. All rights reserved.</p>
                <p>Email: <a href="mailto:info@huntorca.com">info@huntorca.com</a></p>
            </footer>
        </div>
    );
};

export default Solutions; 